// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"773c36cd","160":"6a235416","212":"57249b11","273":"8f797fb9","316":"35fd270a","320":"20a9ec2a","383":"f18810c0","564":"8ad90bdb","582":"3dd05a1b","635":"fc1006a6","943":"8a20e512"}[chunkId] + ".chunk.js";
};